export enum ContactClassificationStatus {
  PendingApproval = "PendingApproval",
  Approved = "Approved",
  Rejected = "Rejected",
  PendingCompletion = "PendingCompletion",
  Cancelled = "Cancelled",
  CompletionReturned = "CompletionReturned",
}
